<template>
	<div class="display-flex flex-direction-column-smo flex-wrap-wrap gap-50-smo gap-100-md">
		<div
			v-for="(stat, i) in props.statistics"
			:key="i"
			:class="`px-150 py-100 display-flex flex-direction-column-md gap-25-md align-items-center-smo justify-content-space-between-smo fund-key-stat ${backgroundColor}`"
		>
			<div :class="['heading-2 order-1-smo', { 'text-color-white': isDarkMode }]">{{ stat.value }}</div>
			<div>
				<BaseTooltip>
					<template #trigger
						><span :class="`${labelColor} body-sm`">{{ stat.label }}</span
						><sup v-if="stat.footnote">{{ stat.footnote }}</sup></template
					><span>{{ stat.tooltipText }}</span>
				</BaseTooltip>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { FundKeyStatistic } from 'types/reit-details';
import { useUserStore } from '../../stores/user';

interface Props {
	statistics: Array<FundKeyStatistic>;
	theme?: 'light' | 'dark';
}

const props = withDefaults(defineProps<Props>(), {
	theme: 'light'
});

const userStore = useUserStore();

const isProOrPremium = computed((): boolean => userStore.isProOrPremium);

const isDarkMode = computed((): boolean => props.theme === 'dark');

const backgroundColor = computed((): string => {
	if (isDarkMode.value) {
		return 'bg-color-gray-80';
	} else if (isProOrPremium.value) {
		return 'bg-color-greige';
	} else {
		return 'bg-color-core';
	}
});

const labelColor = computed((): string =>
	isDarkMode.value ? 'text-color-bg-tertiary' : 'text-color-content-secondary'
);
</script>
<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use '../../styles/utilities/respond-to.scss' as *;

.fund-key-stat {
	border-radius: 2px;

	@include respond-to(md) {
		max-width: 198px;
	}
}

.bg-color-core {
	background-color: rgba(token('data-secondary'), 0.3);
}
</style>
